import axios from "../utils/axiosConfig";
import publicAxios from "../utils/publicAxios";

import { IOrganizationDetails, IOrgProfileData } from "../Interfaces/IorgProfile";
const { BASE_URL } = require("../utils/urls");
//const API_URL = "https://panaccoapi-453601304730.asia-south1.run.app/api/auth";
//const API_URL = "http://localhost:8080/api/auth";
//const API_URL="https://panaccoapi-uat-1082177167010.asia-south1.run.app/api/auth"
const API_URL=`${BASE_URL}/api/auth`;
export const createOrgProfile = async (data: Partial<IOrgProfileData>) => {
  try {
    data.OwnerName=data.OrgName;//Need to handle 
    data.status="Active";//Default value
    data.userType="Admin";//Default value
    data.sysIP="192.168".toString();
    const response = await publicAxios.post(`${API_URL}/createAuth`, data);
    return response.data; // Return the API response
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message || "Something went wrong while saving the organization profile."
    );
  }
};

export const getOrganizationDetails = async (orgId: string) => {
  try {
    const response = await axios.get(`${API_URL}/getOrgDetails`, {
      params: { orgId },
    });
    const data = response.data;
    if (data.success) {
      return data.data[0];
    } else {
      throw new Error(data.message || "Failed to fetch organization details.");
    }
  } catch (error: any) {
    console.error("Error fetching organization details:", error);
    throw error.response?.data || error;
  }
};

export const editOrgProfile = async (data: Partial<IOrganizationDetails>) => {
  try {
    
    data.OwnerName=data.OwnerName;//Need to handle 
    data.status="Active";//Default value
    data.userType="Admin";//Default value
    //data.sysIP="192.168".toString();
    const response = await axios.put(`${API_URL}/editOrg`, data);
    return response.data; // Return the API response
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message || "Something went wrong while saving the organization profile."
    );
  }
};
// Function to handle logo upload
export const uploadOrgLogo = async (file: File) => {
  try {
    console.log(file)
    const formData = new FormData();
    formData.append('file', file);

    const response = await axios.post(`${API_URL}/uploadImage`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error uploading logo:", error);
    throw error;
  }
};
